import React from 'react'

function Cart2() {
  return (
    <div>No Claimed Yet</div>
  )
}

export default Cart2